import { Component } from "solid-js";
export const Required : Component = () => <span style="color: red;" class="fa fa-star"></span>;